import { render, staticRenderFns } from "./CustomersBulkChange.vue?vue&type=template&id=65af08d8&scoped=true"
import script from "./CustomersBulkChange.vue?vue&type=script&lang=js"
export * from "./CustomersBulkChange.vue?vue&type=script&lang=js"
import style0 from "./CustomersBulkChange.vue?vue&type=style&index=0&id=65af08d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af08d8",
  null
  
)

export default component.exports